/* eslint-disable */
<template>
  <div class="newcustomers">
    <div style="margin-bottom:20px">新客户运营</div>
    <div class="mewebox">
      <div class="left_box">
        <div class="search_box">
          <el-button type="primary" icon="el-icon-plus" @click="addprogramme">新建方案</el-button>
          <div style="display:flex;flex-wrap:nowrap;gap:1vw;"><el-input v-model="programmequery.keywords" style="width:150px;" placeholder="搜方案" /><el-button type="primary" icon="el-icon-search" @click="searcher" /></div>
        </div>
        <div v-loading="loading" class="searchwer_box">
          <div v-for="item,index in programme" :key="index" :class="['serqw_item',item.id===active?'serqw_item_active':'',]" @click.stop="activeclick(item.id,index)">
            <div class="serwew_dwrt">
              <div class="adesr">
                <div v-if="item.edit === false">{{ item.name }}</div>
                <el-input v-else ref="pkgId" v-model="item.name" v-focus autofocus="true" placeholder="请输入内容" @blur="serwr(item)" />
                <i style="margin-left: 5px;" class="el-icon-edit" @click="editr(item,index)" />
              </div>
              <div class="adesr">
                <span @click.stop>
                  <el-switch
                    v-model="item.status"
                    style="margin-right:10px"
                    :active-value="1"
                    :inactive-value="2"
                    @change="serwrchanger(item)"
                  />
                </span>
                <el-popover
                  placement="right"
                  width="30"
                  trigger="hover"
                >
                  <el-popconfirm
                    confirm-button-text="确定"
                    cancel-button-text="取消"
                    icon="el-icon-info"
                    icon-color="red"
                    title="确定要删除吗？"
                    @onConfirm="confirm(item)"
                  >
                    <el-button slot="reference">删除</el-button>
                  </el-popconfirm>
                  <div slot="reference"><i class="el-icon-more" /></div>
                </el-popover>
              </div>
            </div>
            <div class="line" />
            <div class="serwew_dwrt">
              <div class="adesr">
                <div style="color:#c6ccd5">ID: {{ item.id }}</div>
                <el-tag style="margin-left: 5px;">{{ item.corp_name }}</el-tag>
              </div>

              <div style="color:#c6ccd5">{{ item.realName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-loading="dawerloading" class="right_box">
        <div class="sdewrw">规则设置</div>
        <div v-if="active === null" class="tetrrw mobile">请选择左侧方案</div>
        <div v-else class="sdewrwrw">
          <div class="rulewr_box" style="align-items: baseline;">
            <div class="tryewe">自动打标签：</div>
            <div><el-tag v-for="item,index in dialogCheckedCitiesarr" :key="index" style="margin-right: 10px;margin-bottom: 5px;" closable @close="close(item.tag_id,index)">{{ item.tag_name }}</el-tag><el-button size="mini" type="primary" icon="el-icon-plus" @click="chooselel">重新选择标签</el-button></div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe" />
            <div class="tipsr"><i class="el-icon-info" style="color: #2d6cff;margin-right: 10px;" />新用户添加后自动打设置的标签</div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe">自动备注：</div>
            <div class="adesr"><el-switch
              v-model="auto_remark"
              :active-value="2"
              :inactive-value="1"
              style="margin-right:10px"
            /><span>{{ value? '已开启': '未开启' }}</span></div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe">客户添加备注格式：</div>
            <div class="dwerww">
              <div class="ldslew">
                <el-button v-for="item,indexse in labelarr" :key="indexse" @click="laserwr(item)">{{ item.name }}</el-button>
              </div>
              <div class="laberr_box">
                <div class="adesr" style="flex-wrap: wrap;">
                  <div v-for="item,index in remark_type" :key="index" style="margin: 0 10px 10px 0px;">
                    <el-tag closable @close="remarkclose(index)">{{ item.name }}</el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe">描述信息：</div>
            <div class="dwerww">
              <div class="ldslew">
                <el-button v-for="item,indexse in miaoshuarr" :key="indexse" @click="laserwrmiao(item)">{{ item.name }}</el-button>
              </div>
              <div class="laberr_box">
                <div class="adesr" style="flex-wrap: wrap;">
                  <div v-for="item,index in description_type" :key="index" style="margin: 0 10px 10px 0px;">
                    <el-tag closable @close="remarkclosemiao(index)">{{ item.name }}</el-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe">客户删除备注格式：</div>
            <div class="dwerww">
              <div class="ldslew">
                <el-button v-for="item,indexse in delLabelarr" :key="indexse" @click="delLaserwr(item)">{{ item.name }}</el-button>
                <el-input
                  v-model.trim="delimiter"
                  style="width: 120px;margin-left: 50px;"
                  maxlength="5"
                  show-word-limit
                  placeholder="请输入"
                />
                <el-button
                  type="primary"
                  class="but"
                  @click="initDelimiter"
                >初始化删除备注</el-button>
              </div>
              <div class="laberr_box">
                <div class="adesr" style="flex-wrap: wrap;">
                  <div v-for="item,index in del_remark_type" :key="index" style="margin: 0 10px 10px 0px;">
                    <el-tag closable @close="delRemarkclose(index)">{{ item.name }}</el-tag>
                  </div>
                </div>
                <div v-if="delimiter&&del_remark_type.length!==0" class="adesr" style="flex-wrap: wrap;">
                  <el-tag type="info">{{ delimiter }}-{{ flattened }}</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="rulewr_box">
            <div class="tryewe">选择人员：</div>
            <div style="width: 810px; max-height: 200px; overflow: auto">
              <el-tag v-for="item,indexr in staffarr" :key="indexr" style="margin-right: 10px;margin-bottom: 5px;" closable @close="closestaff(indexr)">{{ item.name }}</el-tag>
            </div>
            <div><el-button type="primary" icon="el-icon-plus" @click="choosestaff">选择人员</el-button></div>
          </div>
          <div style="text-align: center;margin-top: 80px;">
            <el-button type="primary" icon="el-icon-folder-checked" @click="save">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <pagination-right
      style="padding:0px;margin-top:20px;justify-content:left"
      :total="total"
      :current-page="programmequery.page"
      :page-sizes="[50]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新建方案"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="newschemedialogVisibler"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="30%"
    >
      <newscheme ref="newschemeview" @updata="updata" />
    </el-dialog>
    <el-dialog
      title="选择标签"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="labeldialogVisibler"
      :close-on-click-modal="false"
      width="30%"
    >
      <chooselabel ref="chooselabelview" @callback="callback" @addlabel="addlabel" />
    </el-dialog>
    <el-dialog
      title="选择员工"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="staffdialogVisibler"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import newscheme from './components/newscheme.vue'
import chooselabel from './components/chooselabel.vue'
import bandstaff from './components/bandstaff.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { corpTag, plansList, planDetail, storeTagPlan, storeTagPlanName, delRemarkInit } from '@/api/officialaccount.js'
import Vue from 'vue'
Vue.directive('focus', {
  inserted: function(el) {
    el.querySelector('input').focus()
  }
})
export default {
  nane: 'Newcustomersoperate',
  components: { newscheme, chooselabel, bandstaff, PaginationRight },
  data() {
    return {
      input: '',
      value: true,
      programme: [],
      programmequery: {
        page: 1,
        page_size: 50,
        keywords: null
      },
      delimiter: null,
      active: null,
      newschemedialogVisibler: false,
      labeldialogVisibler: false,
      staffdialogVisibler: false,
      dialogCheckedCities: [],
      dialogCheckedCitiesarr: [],
      data: [],
      index: null,
      staffarr: [],
      auto_remark: null,
      remark_type: [],
      del_remark_type: [],
      labelarr: [{
        id: 1,
        name: '微信昵称'
      },
      {
        id: 2,
        name: '性别'
      },
      {
        id: 3,
        name: '添加日期'
      }, {
        id: 4,
        name: '获客参数'
      }],
      delLabelarr: [{
        id: 1,
        name: '微信昵称'
      },
      {
        id: 2,
        name: '性别'
      },
      {
        id: 3,
        name: '添加日期'
      },
      {
        id: 5,
        name: '删除序号'
      }],
      remark_typechuan: [],
      employee_noschuan: [],
      total: null,
      loading: false,
      dawerloading: false,
      miaoshuarr: [{ id: 6, name: '问答参数' }],
      description_type: [],
      description_typechuan: []
    }
  },
  computed: {
    flattened() {
      return this.del_remark_type.map(item => item.name).join('-')
    }
  },
  // watch: {
  //   delimiter(newVal, old) {
  //     console.log('old:', old)
  //     const regex = /^[,;:|\/\s]+$/
  //     const aa = this.delimiter
  //     if (regex.test(newVal)) {
  //       console.log('newVal:', newVal)
  //       this.delimiter = newVal // 清空输入框内容
  //     } else {
  //       this.delimiter = ''
  //     }
  //   }
  // },
  created() {
    this.programmelist()
    this.active = null
  },
  activated() {
    this.active = null
    this.programmelist()
  },
  mounted() {
  },
  methods: {
    initDelimiter() {
      this.$confirm('您确定初始化删除备注吗')
        .then(async() => {
          const employee_noschuan = this.staffarr.map((item) => {
            return item.employee_no
          })
          await delRemarkInit({ id: this.active, employee_nos: employee_noschuan })
          this.$message({
            message: '初始化成功',
            type: 'success'
          })
          this.getDatas()
        })
        .catch(() => {})
    },
    async confirm(item) {
      console.log('删除', item)
      const data = await storeTagPlanName({
        name: item.name,
        status: 9,
        id: item.id,
        corp_id: item.corp_id
      })
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      // eslint-disable-next-line eqeqeq
      if (this.programme[this.index].id == item.id) {
        this.active = null
      }
      this.programmelist()
      console.log('data', data)
    },
    async activeclick(id, index) {
      this.active = id
      this.index = index
      this.dawerloading = true
      const data = await planDetail({
        id: id
      })
      this.auto_remark = data.data.auto_remark
      this.remark_type = data.data.remark_type
      this.delimiter = data.data.del_prefix
      this.del_remark_type = data.data.del_remark_type
      this.staffarr = data.data.employee_nos
      this.description_type = data.data.description_type
      this.dialogCheckedCities = data.data.tags.map(item => { // item是数组中的每一个值
        return item.tag_id
      })
      this.dialogCheckedCitiesarr = data.data.tags
      this.dawerloading = false
      this.taglist()
      console.log('data9', data)
    },
    addprogramme() {
      this.newschemedialogVisibler = true
    },
    async save() {
      if (this.dialogCheckedCities.length === 0) {
        this.$message.error('请选择标签')
        return
      }
      if (this.staffarr.length === 0) {
        this.$message.error('请选择人员')
        return
      }
      this.remark_typechuan = []
      this.remark_typechuan = this.remark_type.map((item) => {
        return item.id
      })
      let del_remark_type = []
      del_remark_type = this.del_remark_type.map((item) => {
        return item.id
      })
      this.employee_noschuan = []
      this.employee_noschuan = this.staffarr.map((item) => {
        return item.employee_no
      })
      this.description_typechuan = []
      this.description_typechuan = this.description_type.map((item) => {
        return item.id
      })
      const data = await storeTagPlan({
        auto_remark: this.auto_remark,
        id: this.programme[this.index].id,
        remark_type: this.remark_typechuan,
        del_remark_type: del_remark_type,
        tags: this.dialogCheckedCities,
        del_prefix: !this.delimiter ? '' : this.delimiter,
        employee_nos: this.employee_noschuan,
        description_type: this.description_typechuan
      })
      this.$message({
        type: 'success',
        message: '保存成功!'
      })
      console.log('this.programme[this.index].corp_id', this.programme[this.index].id, data)
    },
    searcher() {
      this.active = null
      this.programmequery.page = 1
      this.programmelist()
    },
    // 方案列表
    async programmelist() {
      this.loading = true
      const data = await plansList(this.programmequery)
      data.data.list.forEach(element => {
        element.edit = false
      })
      this.programme = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data.data.list)
    },
    updata() {
      this.newschemedialogVisibler = false
      this.programmequery.keywords = null
      this.programmelist()
    },
    chooselel() {
      this.labeldialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chooselabelview.send(this.programme[this.index].corp_id, this.dialogCheckedCities)
      })
    },
    callback(dialogCheckedCities) {
      this.taglist()
      this.labeldialogVisibler = false
      this.dialogCheckedCities = dialogCheckedCities
      console.log('dialogCheckedCities', dialogCheckedCities)
      this.dialogCheckedCitiesarr = []
      for (let i = 0; i < this.data.length; i++) {
        for (let k = 0; k < this.dialogCheckedCities.length; k++) {
          // eslint-disable-next-line eqeqeq
          if (this.data[i].tag_id == this.dialogCheckedCities[k]) {
            this.dialogCheckedCitiesarr.push(this.data[i])
          }
        }
      }
      console.log(this.dialogCheckedCitiesarr)
    },
    async taglist() {
      const data = await corpTag({
        corp_id: [this.programme[this.index].corp_id]
      })
      this.data = this.fnTree(data.data)
    },
    // 获取所有的子集
    fnTree(arr) { // 取树状数据的所有子集
      return arr.reduce((prev, cur) => {
        return prev.concat(cur.children && cur.children.length ? this.fnTree(cur.children) : cur)
      }, [])
    },
    close(id, index) {
      for (let k = 0; k < this.dialogCheckedCities.length; k++) {
        // eslint-disable-next-line eqeqeq
        if (this.dialogCheckedCities[k] == id) {
          this.dialogCheckedCities.splice(k, 1)
        }
      }
      this.dialogCheckedCitiesarr.splice(index, 1)
      console.log(' this.dialogCheckedCities', this.dialogCheckedCities)
    },
    editr(item, index) {
      item.edit = !item.edit
      // this.$nextTick(() => {
      //   this.$refs.pkgId[this.index].focus()
      // })
    },
    async serwr(item) {
      console.log('失焦', item)
      item.edit = false
      try {
        const data = await storeTagPlanName({
          name: item.name,
          status: item.status,
          id: item.id,
          corp_id: item.corp_id
        })
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.programmelist()
        console.log('data', data)
      } catch {
        this.programmelist()
      }
    },
    async serwrchanger(item) {
      try {
        const data = await storeTagPlanName({
          name: item.name,
          status: item.status,
          id: item.id,
          corp_id: item.corp_id
        })
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.programmelist()
        console.log('data', data)
      } catch {
        this.programmelist()
      }
    },
    choosestaff() {
      console.log(this.programme[this.index])
      this.staffdialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.programme[this.index].corp_id, this.staffarr)
      })
    },
    bandarr(arr) {
      this.staffdialogVisibler = false
      this.staffarr = arr
      console.log('arr', arr)
    },
    closestaff(index) {
      this.staffarr.splice(index, 1)
    },
    laserwr(item) {
      const indexs = this.remark_type.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return item.id == items.id
      })
      if (indexs === -1) {
        this.remark_type.push(item)
      } else {
        this.$message.error('请勿重复添加')
      }
    },
    laserwrmiao(item) {
      const indexs = this.description_type.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return item.id == items.id
      })
      if (indexs === -1) {
        this.description_type.push(item)
      } else {
        this.$message.error('请勿重复添加')
      }
    },
    delLaserwr(item) {
      const indexs = this.del_remark_type.findIndex(items => {
        // eslint-disable-next-line eqeqeq
        return item.id == items.id
      })
      if (indexs === -1) {
        this.del_remark_type.push(item)
      } else {
        this.$message.error('请勿重复添加')
      }
    },
    remarkclose(index) {
      this.remark_type.splice(index, 1)
    },
    delRemarkclose(index) {
      this.del_remark_type.splice(index, 1)
    },
    remarkclosemiao(index) {
      this.description_type.splice(index, 1)
    },
    // 分页
    fetchPageSize(e) {
      this.programmequery.page_size = e
      this.programmelist()
    },
    fetchCurrentPage(e) {
      this.programmequery.page = e
      this.active = null
      this.programmelist()
    },
    addlabel() {
      this.taglist()
      // this.labeldialogVisibler = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
  .adesr{
    display: flex;
    align-items: center;
  }
  .newcustomers{
    padding:30px
  }
  .mewebox{
    display: flex;
    border-top: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }
  .left_box{
    width: 500px;
    flex-shrink: 0;
  }
  .search_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 71px;
    border-bottom: 1px solid #e8e8e8;
    padding: 0px 10px;
  }
  .searchwer_box{
    background-color: #f0f0f0;
    padding: 10px;
    max-height: 900px;
    overflow: auto;
    margin-top: 10px;
  }
  .serqw_item{
    border: 1px solid #ccc;
    background: white;
    padding: 15px 20px;
    margin-bottom: 15px;
    border-radius: 8px;
    cursor: pointer;
  }
  .serqw_item_active{
    border: 1px solid #557395;
    background: #ebf2ff;
  }
  .serwew_dwrt{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .line{
    height:1px;
    background-color: #e3eaf5;
    margin-top: 20px;
    margin-bottom: 15px;
  }
  .right_box{
    width: 100%;
    border-left: 1px solid #e8e8e8;
  }
  .sdewrw{
    height: 71px;
    line-height: 71px;
    border-bottom: 1px solid #e8e8e8;
    padding-left: 20px;
  }
  .sdewrwrw{
    padding-left: 30px;
    padding-top: 30px;
  }
  .rulewr_box{
    display: flex;
    align-items: center;
    margin-bottom: 31px;
  }
  .tryewe{
    /* width: 124px; */
    width: 150px;

  }
  .tipsr{
    width: 800px;
    height: 40px;
    line-height: 40px;
    padding-left: 14px;
    background: #ebf2ff;
  }
  .dwerww{
    width: 800px;
    border: 1px solid #eaeaea;
  }
  .ldslew{
    padding: 15px;
    background: #f9f9f9;
    border-bottom: 1px solid #e8e8e8;
    position: relative;
    left: 0;
    bottom: 0;
  }
  .but{
    position: absolute;
    right: 10px;
    top: 15px;
  }
  .laberr_box{
    padding: 15px;
  }
  .tetrrw{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: rgb(168, 161, 149);
  }
  /*滚动条宽度和颜色设置*/
::-webkit-scrollbar {
    width: 7px;
    height: 7px;
    background-color: #EFEFEF;
}
/*滚动条轨道的颜色*/
::-webkit-scrollbar-track {
    background-color: #EFEFEF;
}
/*滚动条的小圆球颜色*/
::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 110px;
}
@media (max-width: 768px){
    .mewebox,.left_box{
      flex-direction:column;
      width:100%;
    }
    .searchwer_box,.serqw_item_active{
      width:100%;
    }
    .ldslew{
      display:flex;
      flex-wrap:wrap;
    }
    .newcustomers{
      padding:5vw 2vw;
    }
    .but{
      position:relative;
    }
    .mobile{
      display:none;
    }
}
</style>
